module.exports = __webpack_public_path__ + "img/55.5ee05952.jpg";